import { render, staticRenderFns } from "./SchoolRank.vue?vue&type=template&id=43e6da69&scoped=true&"
import script from "./SchoolRank.vue?vue&type=script&lang=js&"
export * from "./SchoolRank.vue?vue&type=script&lang=js&"
import style0 from "./SchoolRank.vue?vue&type=style&index=0&id=43e6da69&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e6da69",
  null
  
)

export default component.exports